import styled from "styled-components";

export const StyledChevron = styled.div`
  a {
    margin-left: auto;
    width: 20px;
    display: block;

    span {
      svg {
        width: 10px;
      }
    }
  }
`;
